export const environment = {
  production: false,
  api: 'https://dev.backendapi.appliedbiox.com/api/v1',
  auth0: {
    domain: 'dev-k81cxnrfzle2ohvb.us.auth0.com',
    clientId: 'Jb1QObPhLAln9EgI72gnHc957giHu9Xs',
    authorizationParams: {
      audience: 'http://abx-api-admin.com',
      redirect_uri: 'https://dev.admin.appliedbiox.com',
    },
    errorPath: '/error',
  },
  calendarUrl: 'https://dev.calendar.appliedbiox.com',
  stripePKey: 'pk_test_51LcHxNCSE2tS1SEMSVHckkw4rFpfAtUNwTXDp4vW8WSu23egXYuhecUqFqMelJ1FICxyzvVbQ2mR2u8YrpQdlkgO00Scu96jdl',
  portalName: 'admin',
  stripePlanUrl: 'https://billing.stripe.com/p/login/test_3cs3dGf5Ta63cgwcMM',
  companyId: 'abx',
  stripe_package_price_1: 'original-hydro-price-per-test',
  stripe_package_price_2: 'price_1Lq0j3CSE2tS1SEMscdRcuzb',
  stripe_package_price_3: 'price_1PgzgBCSE2tS1SEMZcrayWuL',
  stripe_package_price_4: 'price_1PgzpCCSE2tS1SEMZ6yYKvy8',
  stripe_package_price_5: 'price_1Pgzs9CSE2tS1SEMbHXk1sb9',
  stripe_package_price_6: 'price_1PgzsrCSE2tS1SEMSHkpydxD',
  stripe_package_price_7: 'price_1PgzqcCSE2tS1SEMCL7w9xlJ',
  // Gate 2 maintenance switch. Unset (or anything but "true") → live (false).
  maintenanceMode: ''.toLowerCase() === 'true',
  // Embedded ROPG login (login redesign, ADR-0033). ADMIN requires its own
  // EMBEDDED_LOGIN_ENABLED_ADMIN var — the staff portal is higher-privilege and
  // must opt into the MFA-bypassing path separately (OWASP A04 finding).
  // Unset (or anything but "true") → redirect flow.
  embeddedLoginEnabled: ''.toLowerCase() === 'true',
  // Frontend Sentry error reporting (#2191). Unset (or anything but "true") → inert.
  sentryEnabled: ''.toLowerCase() === 'true',
  sentryDsn: '',
  // #2735 — gates the untested admin scanner check-in input (scan field, Check
  // in button, tip) behind a build-time flag. Unset (or anything but "true") →
  // hidden (off). Wired through tools/scripts/generate-env.mjs from
  // ADMIN_SCAN_CHECKIN_ENABLED; the email-search flow stays visible regardless.
  adminScanCheckinEnabled: ''.toLowerCase() === 'true',
};
